import { COUNTRIES, STATES } from '../../tn.common';
import fieldGroupAddressTemplate from '../partials/fieldGroupAddress.html';

tnFieldGroupAddress.$inject = ['tn.billing.service'];
export default function tnFieldGroupAddress(billingService) {
    return {
        template: fieldGroupAddressTemplate,
        scope: {
            model: '=',
            fullName: '=?',
        },
        require: '^form',
        link: function (scope, element, attrs, form) {
            scope.form = form;
            scope.countries = COUNTRIES;
            scope.startsWith = startsWith;
            scope.states = STATES;
            scope.updateAddressFromZipcode = updateAddressFromZipcode;

            function startsWith(state, viewValue) {
                // returns if the given state starts with the text in viewValue
                if (viewValue === null) {
                    return false;
                }
                return (
                    state.substr(0, viewValue.length).toLowerCase() ===
                    viewValue.toLowerCase()
                );
            }

            function updateAddressFromZipcode(country, zipcode) {
                if (scope.form.country.$valid && scope.form.zipcode.$valid) {
                    billingService
                        .zipcodeLookup(country, zipcode)
                        .then((res) => {
                            scope.model.city = res.data.places[0]['place name'];
                            scope.model.state =
                                res.data.places[0]['state abbreviation'];
                        });
                }
            }
        },
        controller: 'tnTypeaheadController',
    };
}
